import * as React from 'react'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Page} from '@vio/core/src/analytics/types/Events'

import {DesktopBaseLayout} from './BaseDesktop'
import {MobileBaseLayout} from './BaseMobile'

interface PropsType {
  hasHeaderSearchSummary?: boolean
  hasHeaderOnMobile?: boolean
  hasHeaderMenuOnMobile?: boolean
  hasHeaderDividerOnMobile?: boolean
  hasHeaderFixedOnDesktop?: boolean
  hasFooterOnMobile?: boolean
  hasSearchProgressBar?: boolean
  hasSearchForm?: boolean
  displayFixedFullScreen?: boolean
  hasMobileHeaderBackButton?: boolean
  mobileHeaderTitle?: React.ReactElement
  hasFilters?: boolean
  customSearchBox?: React.ReactElement
  page?: Page
}

const Layout: React.FC<React.PropsWithChildren<PropsType>> = ({
  children,
  hasHeaderSearchSummary = false,
  hasHeaderOnMobile = true,
  hasHeaderMenuOnMobile = true,
  hasHeaderDividerOnMobile = false,
  hasHeaderFixedOnDesktop = true,
  hasSearchProgressBar = false,
  hasFooterOnMobile = true,
  hasSearchForm = false,
  hasMobileHeaderBackButton,
  mobileHeaderTitle,
  hasFilters = false,
  customSearchBox,
  page
}) => {
  const {isMobile} = useDeviceLayout()

  if (isMobile) {
    return (
      <MobileBaseLayout
        hasHeaderSearchSummary={hasHeaderSearchSummary}
        hasSearchForm={hasSearchForm}
        hasHeader={hasHeaderOnMobile}
        hasHeaderMenu={hasHeaderMenuOnMobile}
        hasHeaderDivider={hasHeaderDividerOnMobile}
        hasSearchProgressBar={hasSearchProgressBar}
        hasFooter={hasFooterOnMobile}
        hasBackButton={hasMobileHeaderBackButton}
        headerTitle={mobileHeaderTitle}
        page={page}
      >
        {children}
      </MobileBaseLayout>
    )
  }

  return (
    <DesktopBaseLayout
      hasSearchForm={hasSearchForm}
      hasFilters={hasFilters}
      hasFixedHeader={hasHeaderFixedOnDesktop}
      hasSearchProgressBar={hasSearchProgressBar}
      customSearchBox={customSearchBox}
    >
      {children}
    </DesktopBaseLayout>
  )
}

export default Layout
